import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './pages/LandingPage'
import LegalMentions from './pages/LegalMentions';
import CGU from './pages/CGU';
import ScrollToTop from './components/ScrollToTop';
import PartenairesPage from './pages/PartenairesPage';
import PartenairesCategoryPage from './pages/PartenairesCategoryPage';
import Navbar from './components/layout/NavBar';
import Footer from './components/layout/Footer';


const App = () => {
  return (
    <Router>
      <div className="bg-[#FFF]">
         <ScrollToTop />
              <Navbar/>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/mentions-legales' element={<LegalMentions />} />
          <Route path='/cgu' element={<CGU />} />
          <Route path='/partenaires' element={<PartenairesPage />} />
          <Route path="/partenaires/:category" element={<PartenairesCategoryPage />} />
        </Routes>

        <Footer/>
      </div>
    </Router>
  );
};

export default App;
